import { render, staticRenderFns } from "./IconClipboardListSolid.vue?vue&type=template&id=42b8c375"
import script from "./IconClipboardListSolid.vue?vue&type=script&lang=js"
export * from "./IconClipboardListSolid.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports